import {DataSource} from '@angular/cdk/collections';
import {MatPaginatorIntl} from '@angular/material';
import {BehaviorSubject, Observable} from 'rxjs';

export class NpaDatabase {
    dataChange: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

    constructor(rows: any | any[]) {
        rows = rows || [];
        rows.forEach((row: any) => {
            this.add(row, true);
        });
    }

    add(row: any, push?: boolean) {
        const copiedData = this.data.slice();
        if (push) {
            copiedData.push(row);
        } else {
            copiedData.unshift(row);
        }
        this.dataChange.next(copiedData);
    }


    delete(id: number, conditions?: string[]) {
        const data = this.data;
        const finalData = [];

        data.forEach((row: any) => {
            if (conditions) {
                let isTargetRow = true;
                conditions.forEach(current => {
                    isTargetRow = isTargetRow &&
                        row[current] && id === row.id;
                });
                if (!isTargetRow) {
                    finalData.push(row);
                }
            } else {
                if (id !== row.id) {
                    finalData.push(row);
                }
            }
        });
        this.dataChange.next(finalData);
    }

    edit(editedRow: any, conditions?: string[]) {
        const data = this.data;
        const finalData = [];
        data.forEach((row: any) => {

            if (conditions) {
                let isTargetRow = true;
                conditions.forEach((current: string) => {
                    isTargetRow = isTargetRow &&
                        editedRow[current] &&
                        row[current] &&
                        editedRow[current] === row[current];
                });
                finalData.push(isTargetRow ? editedRow : row);
            } else {
                finalData.push(editedRow.id === row.id ? editedRow : row);
            }

        });
        this.dataChange.next(finalData);
    }

    get data(): any[] {
        return this.dataChange.value;
    }

}

export class NpaDataSource extends DataSource<any> {
    constructor(public domesticDatabase: NpaDatabase) {
        super();
    }

    connect(): Observable<any[]> {
        return this.domesticDatabase.dataChange;
    }

    disconnect() {
    }
}

export function formatPaginator(matPaginatorIntl: MatPaginatorIntl) {
    const lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'prs';
    let rangeLabel;

    if(lang=='ps'){
        matPaginatorIntl.itemsPerPageLabel = 'په صفحه کې د کرښې شمیر:'
        matPaginatorIntl.nextPageLabel = 'بل مخ';
        matPaginatorIntl.previousPageLabel = 'مخکینۍ پاڼه';
        rangeLabel = ' له ';
    }else if(lang=='prs'){
        matPaginatorIntl.itemsPerPageLabel = 'تعداد سطر در صفحه:';
        matPaginatorIntl.nextPageLabel = 'صفحه بعدی';
        matPaginatorIntl.previousPageLabel = 'صفحه قبلی';
        rangeLabel = ' از ';
    }else{
       matPaginatorIntl.itemsPerPageLabel = 'Items per page';
       matPaginatorIntl.nextPageLabel = 'Next page';
       matPaginatorIntl.previousPageLabel = 'Items per page'; 
       rangeLabel = ' from ';
    }
    matPaginatorIntl.getRangeLabel =
        (page: number, pageSize: number, length: number) => {
            if (length === 0 || pageSize === 0) {
                return `0 ` + rangeLabel + ` ${length}`;
            }
            length = Math.max(length, 0);
            const startIndex = page * pageSize;
            const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
            return `${startIndex + 1} - ${endIndex}` + rangeLabel + `${length}`;
        };
}
